import React from 'react';

import Box from '@ui/box/Box.tsx';

import LevelRow from './LevelRow.tsx';

const LevelsList = ({ ref, ...props }) => {
  const {
    levels,
    onLevelClick,
    selectedLevelId,
    buildingName,
    getTreeItemProps,
    id,
    role,
    'aria-label': ariaLabel,
    T,
  } = props;

  return (
    <Box data-testid="LevelsList" ref={ref} id={id} role={role} aria-label={ariaLabel}>
      {Object.values(levels).map(level => {
        const treeMeta = getTreeItemProps
          ? getTreeItemProps({
              type: 'level',
              id: level.id,
              buildingId: level.buildingId,
              itemId: `level-${level.id}`,
            })
          : {};
        return (
          <LevelRow
            buildingName={buildingName}
            key={level.id}
            selectedLevelId={selectedLevelId}
            onLevelClick={onLevelClick}
            treeTabIndex={treeMeta.treeTabIndex}
            treeOnKeyDown={treeMeta.treeOnKeyDown}
            isTreeFocused={treeMeta.isTreeFocused}
            id={level.id}
            name={level.name}
            details={level.details}
            resultsNumber={level.resultsNumber}
            T={T}
          />
        );
      })}
    </Box>
  );
};

LevelsList.displayName = 'Levels List';

export default LevelsList;
